<div class="compliance-report">
  <div class="panel">
    <div class="row align-items-center">
      <div class="col-8">
        <h2>{{'COMPLIANCEREPORT.Title' | translate}}</h2>
      </div>
      <div class="col-4 text-end" *ngIf="!isFromTapro">
        <button class="btn btn-primary" (click)="onBackToDeltaReport()">
          <span class="pi pi-home"></span>
          <span>&nbsp;{{'COMPLIANCEREPORT.ToDeltaReport' | translate}}</span>
        </button>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-6">
        <label class="report-label">{{'COMPLIANCEREPORT.ProjectName' | translate}}:</label>
        <span>&nbsp;{{currentProject?.Name}}</span>
      </div>
      <div class="col-6">
        <label class="report-label">{{'COMPLIANCEREPORT.ProjectId' | translate}}:</label>
        <span>&nbsp;{{currentProject?.ProjectId}}</span>
      </div>
    </div>
  </div>

  <!-- Filters -->
  <div class="panel mt-3">
    <div class="row">
      <div class="col-12">
        <p-selectButton class="hours-tabs" [options]="hoursOptions" [(ngModel)]="selectedHours"
          optionLabel="label" optionValue="value" [allowEmpty]="false" (onChange)="onHoursChange()">
        </p-selectButton>
      </div>
    </div>
    <div class="row align-items-end mt-3">
      <div class="col-sm-5">
        <label class="report-label">{{'COMPLIANCEREPORT.WBSCategory' | translate}}</label>
        <p-multiSelect [options]="wbsCategoryFilterData" [(ngModel)]="selectedWbsCategories"
          optionLabel="WbsCategoryName" [style]="{'width':'100%'}" [filter]="true" (onChange)="applyFilters()"
          placeholder="{{'COMPLIANCEREPORT.SelectCategory' | translate}}">
        </p-multiSelect>
      </div>
      <div class="col-sm-5">
        <label class="report-label">{{'COMPLIANCEREPORT.Job' | translate}}</label>
        <p-multiSelect [options]="ewoOptions" [(ngModel)]="selectedEwo" optionLabel="label"
          optionValue="value" [style]="{'width':'100%'}" [filter]="true" [filterFields]="['label']"
          (onChange)="applyFilters()" placeholder="{{'COMPLIANCEREPORT.SelectJob' | translate}}">
        </p-multiSelect>
      </div>
      <div class="col-sm-2 text-end">
        <p-button class="margin" [raised]="true" severity="danger" (click)="clearFilters()">
          <span>{{'COMPLIANCEREPORT.Clear' | translate}}</span>
        </p-button>
        <p-button class="margin" [raised]="true" severity="success" (click)="applyFilters()">
          <span>{{'COMPLIANCEREPORT.Apply' | translate}}</span>
        </p-button>
      </div>
    </div>
  </div>

  <div *ngIf="report; else noData">
    <!-- Summary cards -->
    <div class="row mt-3">
      <div class="col-sm-3">
        <div class="panel summary-card">
          <span class="summary-title">{{'COMPLIANCEREPORT.TotalPlanned' | translate}}</span>
          <span class="summary-value">{{totalPlanned | number:'1.0-2'}}</span>
        </div>
      </div>
       <div class="col-sm-3">
        <div class="panel summary-card">
          <span class="summary-title">{{'COMPLIANCEREPORT.TotalEarnedshift' | translate}}</span>
          <span class="summary-value">{{totalEarned | number:'1.0-2'}}</span>
        </div>
      </div>
      <div class="col-sm-3">
        <div class="panel summary-card">
          <span class="summary-title">{{'COMPLIANCEREPORT.TotalEarned' | translate}}</span>
          <span class="summary-value">{{totalEarnedAllTime | number:'1.0-2'}}</span>
        </div>
      </div>
      <div class="col-sm-3">
        <div class="panel summary-card">
          <span class="summary-title">{{'COMPLIANCEREPORT.Compliance' | translate}}</span>
          <span class="summary-value">{{compliancePercent | number:'1.0-2'}}%</span>
        </div>
      </div>
    </div>

    <!-- Charts -->
    <div class="row mt-3">
      <div class="col-sm-8">
        <div class="panel chart-panel">
          <h4>{{'COMPLIANCEREPORT.PlannedVsEarned' | translate}}</h4>
          <div class="chart-container chart-dark" *ngIf="groupRows.length > 0; else noChartData">
            <p-chart type="bar" [data]="barData" [options]="barOptions" height="360px"></p-chart>
          </div>
          <ng-template #noChartData>
            <h5>{{'COMPLIANCEREPORT.NoData' | translate}}</h5>
          </ng-template>
        </div>
      </div>
      <div class="col-sm-4">
        <div class="panel chart-panel">
          <h4>{{'COMPLIANCEREPORT.ComplianceOverview' | translate}}</h4>
          <div class="chart-container">
            <p-chart type="doughnut" [data]="complianceData" [options]="complianceOptions" height="360px"></p-chart>
          </div>
        </div>
      </div>
    </div>

    <!-- Detail table with activity drill-down -->
    <div class="panel mt-3" *ngIf="groupRows.length > 0">
      <h4>{{'COMPLIANCEREPORT.Details' | translate}}</h4>
      <p-table [value]="groupRows" dataKey="key" [paginator]="groupRows.length > 10" [rows]="10"
        styleClass="p-datatable-sm p-datatable-striped">
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 3rem"></th>
            <th>{{'COMPLIANCEREPORT.GroupName' | translate}}</th>
            <th class="text-end">{{'COMPLIANCEREPORT.ActivityCount' | translate}}</th>
            <th class="text-end">{{'COMPLIANCEREPORT.PlannedHours' | translate}}</th>
            <th class="text-end">{{'COMPLIANCEREPORT.EarnedHours' | translate}}</th>
            <th class="text-end">{{'COMPLIANCEREPORT.Compliance' | translate}}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item let-expanded="expanded">
          <tr>
            <td>
              <button type="button" pButton [pRowToggler]="item"
                *ngIf="item.activities?.length"
                class="p-button-text p-button-rounded p-button-plain"
                [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
            </td>
            <td>
              <a href="javascript:void(0)" class="category-link" (click)="openCategoryDetail(item)">{{item.name}}</a>
            </td>
            <td class="text-end">{{item.ActivityCount}}</td>
            <td class="text-end">{{item.PlannedLaborHours | number:'1.0-2'}}</td>
            <td class="text-end">{{item.EarnedLaborHours | number:'1.0-2'}}</td>
            <td class="text-end">
              {{ (item.PlannedLaborHours > 0 ? (item.EarnedLaborHours / item.PlannedLaborHours) * 100 : 0) | number:'1.0-2'}}%
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="rowexpansion" let-item>
          <tr>
            <td colspan="6" class="p-0">
              <p-table [value]="item.activities" styleClass="p-datatable-sm nested-table">
                <ng-template pTemplate="header">
                  <tr>
                    <th>{{'COMPLIANCEREPORT.ActivityId' | translate}}</th>
                    <th>{{'COMPLIANCEREPORT.ActivityName' | translate}}</th>
                    <th>{{'COMPLIANCEREPORT.Status' | translate}}</th>
                    <th class="text-end">{{'COMPLIANCEREPORT.PlannedHours' | translate}}</th>
                    <th class="text-end">{{'COMPLIANCEREPORT.EarnedHours' | translate}}</th>
                    <th class="text-end">{{'COMPLIANCEREPORT.Compliance' | translate}}</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-act>
                  <tr>
                    <td>{{act.ActivityId}}</td>
                    <td>{{act.ActivityName}}</td>
                    <td>{{act.InternalStatus}}</td>
                    <td class="text-end">{{act.PlannedLaborHours | number:'1.0-2'}}</td>
                    <td class="text-end">{{act.EarnedLaborHours | number:'1.0-2'}}</td>
                    <td class="text-end">
                      {{ (act.PlannedLaborHours > 0 ? (act.EarnedLaborHours / act.PlannedLaborHours) * 100 : 0) | number:'1.0-2'}}%
                    </td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                  <tr>
                    <td colspan="6">{{'COMPLIANCEREPORT.NoData' | translate}}</td>
                  </tr>
                </ng-template>
              </p-table>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>

  <ng-template #noData>
    <div class="panel mt-3">
      <h5>{{'COMPLIANCEREPORT.NoData' | translate}}</h5>
    </div>
  </ng-template>

  <!-- Category detail dialog -->
  <p-dialog [(visible)]="showCategoryDetail" [modal]="true" [style]="{width: '70vw'}" [draggable]="false"
    [resizable]="false" [dismissableMask]="true">
    <ng-template pTemplate="header">
      <div class="d-flex align-items-center justify-content-between w-100 category-detail-header">
        <div>
          <span class="report-label">{{'COMPLIANCEREPORT.WBSCategory' | translate}}:</span>
          <span>&nbsp;{{selectedCategory?.name}}</span>
        </div>
        <span class="p-input-icon-left search-box">
          <i class="pi pi-search"></i>
          <input type="text" pInputText [(ngModel)]="categorySearch"
            placeholder="{{'SHARED.Filter' | translate}}" />
          <i *ngIf="categorySearch" class="pi pi-times clear-icon"
            (click)="categorySearch = ''"></i>
        </span>
      </div>
    </ng-template>
    <div class="wp-accordion">
      <table class="wp-table">
        <thead>
          <tr>
            <th style="width: 3rem"></th>
            <th>{{'COMPLIANCEREPORT.WorkPackage' | translate}}</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let job of filteredJobs">
            <tr class="wp-row" (click)="toggleJobRow(job)">
              <td>
                <i class="pi" [ngClass]="expandedJobKeys[job.key] ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
              </td>
              <td>
                <a href="javascript:void(0)" class="category-link">{{job.name}}</a>
                <div class="wbs-breadcrumb" *ngIf="wbsBreadcrumb(job.wbsPath).length">
                  <span *ngFor="let segment of wbsBreadcrumb(job.wbsPath); let last = last">
                    <span class="wbs-breadcrumb-item">{{segment}}</span>
                    <span class="wbs-breadcrumb-sep" *ngIf="!last">&nbsp;&#8594;&nbsp;</span>
                  </span>
                </div>
              </td>
            </tr>
            <tr *ngIf="expandedJobKeys[job.key]" class="wp-detail-row">
              <td colspan="2" class="p-0">
                <table class="wp-table nested-table">
                  <thead>
                    <tr>
                      <th class="sortable-header" (click)="sortActivities('ActivityId')">
                        {{'COMPLIANCEREPORT.Activity' | translate}}
                        <i class="pi" *ngIf="activitySortField === 'ActivityId'"
                          [ngClass]="activitySortOrder === 1 ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down'"></i>
                      </th>
                      <th class="text-end sortable-header" (click)="sortActivities('PlannedLaborHours')">
                        {{'COMPLIANCEREPORT.PlannedHours' | translate}}
                        <i class="pi" *ngIf="activitySortField === 'PlannedLaborHours'"
                          [ngClass]="activitySortOrder === 1 ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down'"></i>
                      </th>
                      <th class="text-end sortable-header" (click)="sortActivities('EarnedLaborHours')">
                        {{'COMPLIANCEREPORT.EarnedHours' | translate}}
                        <i class="pi" *ngIf="activitySortField === 'EarnedLaborHours'"
                          [ngClass]="activitySortOrder === 1 ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down'"></i>
                      </th>
                      <th class="text-end">{{'COMPLIANCEREPORT.Compliance' | translate}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let act of sortedActivities(job)">
                      <td>{{act.ActivityId}} - {{act.ActivityName}}</td>
                      <td class="text-end">{{act.PlannedLaborHours | number:'1.0-2'}}</td>
                      <td class="text-end">{{act.EarnedLaborHours | number:'1.0-2'}}</td>
                      <td class="text-end">
                        {{ categoryCompliance(act.PlannedLaborHours, act.EarnedLaborHours) | number:'1.0-2'}}%
                      </td>
                    </tr>
                    <tr *ngIf="!job.activities?.length">
                      <td colspan="4">{{'COMPLIANCEREPORT.NoData' | translate}}</td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </ng-container>
          <tr *ngIf="!filteredJobs.length">
            <td colspan="2">{{'COMPLIANCEREPORT.NoData' | translate}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </p-dialog>
</div>
